import React from "react";

import useStyles from "../tables-container/styles";
import StyledTableCell from "./styled-table-cell.component";

const StubCell = ({ columnsNumber }): JSX.Element => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {[...Array(columnsNumber)].map((item, index) => (
        <StyledTableCell
          className={classes.dataCell}
          key={index}
          align="center"
        >
          ---
        </StyledTableCell>
      ))}
    </React.Fragment>
  );
};

export default StubCell;
